angular
    .module('userNotifications.v1')
    .directive('requiresActionCount', requiresActionCount);

/**
 * @ngdoc directive
 * @name userNotifications.v1.directive:requiresActionCount
 * @restrict A
 * @element any
 *
 * @description
 * Displays the count of all notifications marked as "requires action"
 *
 * #### Script file
 * - `/web3/build/storefront/widgets/requires-action-count.v1.directive.js`
 *
 * #### Classes
 * - `isPending` : applied while notifications are in the proces of loading
 * - `isEmpty` : applied when the total notification count is 0
 *
 * #### Events
 * - `window.events.REQUIRES_ACTION_LIST_UPDATED` : raised whenever the notification count changes
 *
 * @example
    <pre>
        <!-- load widget script -->
        <script src="/web3/build/storefront/widgets/requires-action-count.v1.directive.js"></script>

        <!-- display widget count -->
        <span requires-action-count></span>

        <!-- respond to events -->
        <script>
            window.events.listen(window.events.REQUIRES_ACTION_LIST_UPDATED, function () {
                console.log('requires action count updated');
            });
        </script>
    </pre>
    */

requiresActionCount.$inject = [];

function requiresActionCount () {
    return {
        restrict: 'A',
        template: '<span ng-bind="requiresActionCountController.count"></span>',
        link: function pendingReviewCountDirective_linkFn (scope, element, attrs, controller, transclude) {},
        controller: RequiresActionCountController,
        controllerAs: 'requiresActionCountController',
        bindToController: true,
        scope: {}
    };
};

RequiresActionCountController.$inject = ['$scope', '$element', 'userNotificationsService', 'authService', '$timeout'];

function RequiresActionCountController ($scope, $element, userNotificationsService, authService, $timeout) {
    var vm = this;

    vm.count = 0;

    init();

    return;

    function init () {
        $element
            .addClass('isEmpty')
            .addClass('isPending');
        // Subscribe to auth changes
        authService.subscribe($scope, handleAuthChange);
        // Subscribe to requiresActionItems updates
        userNotificationsService.requiresActionItems.subscribe($scope, handleRequiresActionItemsUpdate);
        // Subscribe to classic events
        userNotificationsService.classicEvents.subscribe($scope, getRequiresActionCount);
        // Initial loading of requiresActionItems
        getRequiresActionCount();
    }

    function handleAuthChange ($event, user) {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        getRequiresActionCount();
    }

    function getRequiresActionCount () {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        userNotificationsService.requiresActionItems.get(authService.getUser().id);
    }

    function handleRequiresActionItemsUpdate ($event, requiresActionItems) {
        if (!requiresActionItems) {
            return resetDirective();
        }

        if (!requiresActionItems.length) {
            $element.addClass('isEmpty');
        } else {
            $element.removeClass('isEmpty');
        }

        $timeout(function(){
            vm.count = requiresActionItems.length;
        });
        $element
            .show()
            .removeClass('isPending');
    }

    function resetDirective () {
        vm.count = 0;
        $element
            .hide()
            .addClass('isEmpty')
            .removeClass('isPending');
    }
};